import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MfpcBaseShowFileDialogComponent } from 'base-form';

@Component({
  selector: 'mfpc-show-file-dialog',
  templateUrl: './mfpc-show-file-dialog.component.html',
  styleUrls: ['./mfpc-show-file-dialog.component.scss'],
})
export class MfpcShowFileDialogComponent extends MfpcBaseShowFileDialogComponent implements OnInit {
  constructor(
    public config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
    protected sanitizer: DomSanitizer
  ) {
    super(sanitizer)
  }

  ngOnInit(): void {
    this.data = this.config.data;
    const byteArray = new Uint8Array(
      atob(this.data.fileBase64.file64)
        .split('')
        .map((char) => char.charCodeAt(0))
    );
    const blob = new Blob([byteArray], {
      type: `application/${this.data.fileBase64.fileExtension}`,
    });
    this.imageSrc = this.toSanitizer(URL.createObjectURL(blob));
  }

  onCloseDialog(): void {
    this.dialogRef.close();
  }
}
